import { render, staticRenderFns } from "./edit-dealer.vue?vue&type=template&id=174e9adc&"
import script from "./edit-dealer.vue?vue&type=script&lang=js&"
export * from "./edit-dealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports